import { closeModal, openModal } from '../../modal';
import { setRegisteredData } from './registered-data';

/*
	Po wysłaniu zgłoszenia pokazujemy komunikat w modalu (_partials/zgloszenie-modal.html.twig),
	a nie podmieniamy stron w sekcji: formularz zostaje na swoim miejscu, więc „kolejne
	zgłoszenie” to zamknięcie okna, a nie kolejna podmiana widoku.

	O tym, które okno leci, decyduje `data.prize` z odpowiedzi — bramki (App\Entity\Gate)
	rozstrzygają wygraną po stronie serwera, front tylko wyświetla wynik.
*/
const MODALS = {
    win: '[data-modal="zgloszenie-wygrana"]',
    loss: '[data-modal="zgloszenie-przegrana"]',
};

$('.application-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    /*
        Event dla klienta (Mondelez): tylko po przyjętym zgłoszeniu, stąd tutaj, a nie
        w `click` na „WYŚLIJ”. Samego dataLayera nie tworzymy — wstawia go skrypt
        z panelu admina; bez niego nie ma kto eventu odebrać.
    */
    if (window.dataLayer !== undefined) {
        window.dataLayer.push({
            event: 'form_send',
            form_id: String(data.id),
        });
    }

    const selector = data.prize ? MODALS.win : MODALS.loss;
    const modal = document.querySelector(selector);
    if (!modal) return;

    // lista zarejestrowanych danych i link do potwierdzenia siedzą w środku modala
    setRegisteredData(data, selector);
    openModal(modal);
});

/*
	„WYŚLIJ” z ramki „Kolejne zgłoszenie” — zamyka okno i wraca do (wyczyszczonego
	przez ajax-form.js) formularza.

	Nie `scrollIntoView()`: zamknięcie okna zdejmuje `overflow-y: hidden` z `body`,
	więc w chwili kliknięcia dokument ma jeszcze wysokość i pozycję sprzed odblokowania
	przewijania. Cel liczony w tamtym momencie wypadał za wysoko i przy każdym kolejnym
	zgłoszeniu strona wspinała się o kilka pikseli. Liczymy więc pozycję BEZWZGLĘDNĄ
	i dopiero w następnej klatce, po przeliczeniu układu.

	Odstęp nad kartą bierzemy z `scroll-margin-top` samej karty — dzięki temu zostaje
	w skali makiety (jednostki `vw`), a nie jako stała w JS-ie.
*/
$('.result-try-again').on('click', function() {
    closeModal(this.closest('[data-modal]'));

    const card = document.querySelector('#application .s-application__card')
        ?? document.getElementById('application');
    if (!card) return;

    requestAnimationFrame(() => {
        const margin = parseFloat(getComputedStyle(card).scrollMarginTop) || 0;
        const top = card.getBoundingClientRect().top + window.scrollY - margin;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
});

$('[name="personal_data[billType]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');
